import React from "react";
import {
  RoleNameBlock2,
  SongBlock2,
  LogoBlock,
  BlurbBlock,
  NameOnlyBlock2,
} from "./BlockType/index";
import "./Block.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const getBlock = (options, items, idx, settings) => {
  switch (options.block_type) {
    case "rolename":
      return <RoleNameBlock2 options={options} items={items} idx={idx} settings={settings} />;
    case "nameonly":
      return <NameOnlyBlock2 options={options} items={items} idx={idx} settings={settings} />;
    case "song":
      return <SongBlock2 options={options} items={items} idx={idx} settings={settings} />;
    case "logo":
      return <LogoBlock options={options} items={items} idx={idx} settings={settings} />;
    case "blurb":
      return <BlurbBlock options={options} items={items} idx={idx} settings={settings} />;
    default:
      return options.block_type || null;
  }
};

export default function Block({ options, items, idx, settings }) {
  const location = useLocation();
  const projectIsCard = useSelector((state) => state.project?.isCard);
  const isCard =
    Boolean(projectIsCard) ||
    Boolean(location.state?.isCard) ||
    /\/dashboard\/card(\/|$)/.test(location.pathname);

  if (!options?.text_alignment) {
    return null; // Avoid rendering if text_alignment is missing
  }

  return (
    <div
      className={`block_ w-full ${isCard ? "h-full items-center CardBlockCententHide" : "items-baseline "}`}
      style={{
        margin: "0 auto",
        padding: "10px 0px",
        display: "flex",
        justifyContent: "center",
        // alignItems: "baseline",
      }}
    >
      {getBlock(options, items, idx, settings)}
    </div>
  );
}
